// take a string like not_enrolled and return Not Enrolled
export const statusHumanize = (value: string) =>
  value
    .split('_')
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ')
